import { render, staticRenderFns } from "./A4_1x2.vue?vue&type=template&id=ebb21674&scoped=true&"
import script from "./A4_1x2.vue?vue&type=script&lang=js&"
export * from "./A4_1x2.vue?vue&type=script&lang=js&"
import style0 from "./A4_1x2.vue?vue&type=style&index=0&id=ebb21674&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb21674",
  null
  
)

export default component.exports